module.exports = __webpack_public_path__ + "img/615.c8ddd022.jpg";